/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export interface InviteUserModalState {
    isOpen: boolean;
}

const initialState: InviteUserModalState = {
    isOpen: false,
};

export const inviteUserModalSlice = createSlice({
    name: 'invite-user-modal',
    initialState,
    reducers: {
        open(state: InviteUserModalState) {
            state.isOpen = true;
        },
        close(state: InviteUserModalState) {
            state.isOpen = false;
        },
    },
}); 